interface ErrorTooltipContentProps {
  text?: string | null;
}

export const ErrorTooltipContent = ({ text }: ErrorTooltipContentProps) => {
  if (text) {
    // Text wrapped in **asterisks** will be bold.
    const parts = text.split(/(\*\*.*?\*\*)/g);

    return (
      <div className="error-tooltip-content" data-testid="error-tooltip-content">
        {parts.map((part, index) =>
          part.startsWith("**") && part.endsWith("**") ?
            <b key={index}>{part.slice(2, -2)}</b>
          : <span key={index}>{part}</span>,
        )}
      </div>
    );
  }
  return null;
};
